import PostingForm from "app/components/PostingForm";
import React, { memo } from "react";
import { useFeedPostingForm } from "./indexModel";
import PostModel from "app/models/PostModel";
import { useTranslation } from "react-i18next";

interface Props {
  onPost?: (post: PostModel) => void;
}

const FeedPostingForm = ({ onPost }: Props) => {
  const { t } = useTranslation();
  const { canSchedulePosts, canUploadMedia, onSubmit } = useFeedPostingForm({
    onPost,
  });

  return (
    <PostingForm
      textAreaPlaceholder={t("Create post...")}
      canUploadMedia={canUploadMedia()}
      canSchedule={canSchedulePosts}
      profilePicture={null}
      postButtonLabel={t("Post")}
      postTextIsRequired
      locationsIsRequired
      onPost={onSubmit}
    />
  );
};

export default memo(FeedPostingForm);
